module.exports = __webpack_public_path__ + "static/media/Group_1597880706@2x.217f96d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_209/images/Group_1597880706@2x.png
// module id = 461
// module chunks = 0